// @ts-strict-ignore
import pick from 'lodash/pick';

import {FilteredBreakdownSegments, LegendOverrides, SavedLegend} from 'common/types/reports/bookmark';

export class Legend {
  // deprecated
  public declare idxSelections: number[] | number[][];
  public declare otherSelections: boolean[];
  public declare overrides: LegendOverrides;

  public declare individualSelectedSegments: SavedLegend;
  public declare filteredBreakdownSegments: FilteredBreakdownSegments;

  constructor(
    attrs: {
      overrides?: LegendOverrides;
      idxSelections?: number[] | number[][];
      otherSelections?: boolean[];
      individualSelectedSegments?: SavedLegend;
      filteredBreakdownSegments?: FilteredBreakdownSegments;
    } = {},
  ) {
    this.overrides = attrs.overrides ?? {};
    // if the preferred individualSelectedSegments or filteredBreakdownSegments are provided, do nothing with deprecated url data
    if (attrs.individualSelectedSegments || attrs.filteredBreakdownSegments) {
      this.individualSelectedSegments = attrs.individualSelectedSegments;
      this.filteredBreakdownSegments = attrs.filteredBreakdownSegments;
    } else {
      this.idxSelections = attrs.idxSelections;
      this.otherSelections = attrs.otherSelections;
    }
  }

  serialize() {
    return {
      ...(this.individualSelectedSegments ? {individualSelectedSegments: this.individualSelectedSegments} : {}),
      ...(this.filteredBreakdownSegments ? {filteredBreakdownSegments: this.filteredBreakdownSegments} : {}),
      ...(this.idxSelections ? {idxSelections: this.idxSelections} : {}),
      ...(this.otherSelections ? {otherSelections: this.otherSelections} : {}),
      ...(this.overrides ? {overrides: this.overrides} : {}),
    };
  }

  toBookmarkData() {
    return pick(this.serialize(), `overrides`, `individualSelectedSegments`, `filteredBreakdownSegments`);
  }

  static deserialize(attrs) {
    return new Legend(attrs);
  }
}
